import { render, staticRenderFns } from "./webhooks.vue?vue&type=template&id=9edaebca&"
import script from "./webhooks.vue?vue&type=script&lang=js&"
export * from "./webhooks.vue?vue&type=script&lang=js&"
import style0 from "./webhooks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports